import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// export lazy route
const LastStep = lazy(() => import("../../components/StepCards/LastStep"));

const ADDCLIENT_ROUTES: RouteObject[] = [
  {
    path: "/private/add-client",
    element: React.createElement(LastStep),
  },
];

export default ADDCLIENT_ROUTES;